// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"770f4e45","380":"c4fc3aba","853":"a267abd5"}[chunkId] + ".chunk.js";
};